import React, { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import { getAuthorities } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/occupation-categories/OccupationCategoriesAction";
import * as uiHelpers from "../OccupationCategoriesUIHelpers";
import { 
  getSelectRow, 
  getHandlerTableChange,  
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useOccupationCategoriesUIContext } from "../OccupationCategoriesUIContext";

export function OccupationCategoriesTable({ deleteCategories }) {
  // Occupation Categories UI Context
  const categoriesUIContext = useOccupationCategoriesUIContext();
  const categoriesUIProps = useMemo(() => {
    return {
      ids: categoriesUIContext.ids,
      setIds: categoriesUIContext.setIds,
      queryParams: categoriesUIContext.queryParams,
      setQueryParams: categoriesUIContext.setQueryParams,
      openEditCategoryPage: categoriesUIContext.openEditCategoryPage
    };
  }, [categoriesUIContext]);

  // Getting curret state of Occupation Categories list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.occupationCategories }),
    shallowEqual
  );
  const { totalCount, entities, authorities, listLoading } = currentState;
  
  // Authority Parameters
  const { isEditionAuthorized, isDeletionAuthorized } = getAuthorities(authorities);
  
  // Occupation Categories Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    // clear selections list
    categoriesUIProps.setIds([]);
    // ...
    dispatch(actions.getCategories(categoriesUIProps.queryParams));
    return () => dispatch(actions.cleanCategoriesState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoriesUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "category",
      text: "Kategori",
      sort: true,
      sortCaret: sortCaret,
    }
  ];

  const actionColumn = {
    dataField: "action",
    text: "İşlemler",
    formatter: columnFormatters.ActionsColumnFormatter,
    formatExtraData: {
      isEditionAuthorized,
      isDeletionAuthorized,
      openEditCategoryPage: categoriesUIProps.openEditCategoryPage,
      deleteCategories
    },
    classes: "text-right pr-0",
    headerClasses: "text-right pr-3",
    style: {
      minWidth: "100px",
    }
  }

  if (isEditionAuthorized || isDeletionAuthorized) columns.push(actionColumn);

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: categoriesUIProps.queryParams.pageSize,
    page: categoriesUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ? entities : [] }
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                categoriesUIProps.setQueryParams
              )}
              selectRow={getSelectRow({
                entities,
                ids: categoriesUIContext.ids,
                setIds: categoriesUIProps.setIds,
                hidden: !isDeletionAuthorized
              })}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}